import {AbstractControl} from '@angular/forms';
import {Base, BaseDTO} from './base';
import { environment } from '../../../environments/environment';
import { formatDateForBackend } from '../../helpers/date.helper';

export interface PopupsFilters {
    title?: string,
    tenant_id?: number;
    onlyCurrentTenant?: boolean;
}

export interface PopupsDTO extends BaseDTO {
    id?: number,
    title?: string,
    content: string,
    start_date: string,
    end_date: string,
    tenant_id: number,
    image?: File
}

export class Popups extends Base {
    title?: string;
    content: string;
    start_date: Date;
    end_date: Date;
    tenant_id: number;
    image: File


    constructor(source: PopupsDTO){
        super(source);
        if(source){
            this.title = source.title;
            this.content = source.content;
            this.start_date = new Date(source.start_date);
            this.end_date = new Date(source.end_date);
            this.tenant_id = source.tenant_id;
            this.image = source.image
        }
    }

    toDTO(): PopupsDTO {
        return {
            ...super.toDTO(),
            title: this.title,
            content: this.content,
            start_date: formatDateForBackend(this.start_date),
            end_date: formatDateForBackend(this.end_date), //this.end_date.toISOString().split('T')[0],
            tenant_id: this.tenant_id,
            image: this.image

        };
    }

    static fromFormGroup(formGroup: AbstractControl, original?: Popups){
        const formModel = formGroup.value;
        let popups = new Popups(null);

        popups.title = formModel.title;
        popups.content = formModel.content;
        popups.start_date = formModel.start_date ? new Date(formModel.start_date) : null;
        popups.end_date = formModel.end_date ? new Date(formModel.end_date) : null;
        popups.tenant_id = formModel.tenant_id;
        popups.image = formModel.image


        if(original){
            popups.id = original.id
        }

        return popups;
    }
}

